import type { ReactNode } from "react";

const paths: Record<string, ReactNode> = {
  accueil: (
    <>
      <path d="M3 11l9-7 9 7" />
      <path d="M5 10v10h14V10" />
      <path d="M10 20v-6h4v6" />
    </>
  ),
  stock: (
    <>
      <rect x="3" y="12" width="8" height="8" rx="1" />
      <rect x="13" y="12" width="8" height="8" rx="1" />
      <rect x="8" y="3" width="8" height="8" rx="1" />
    </>
  ),
  reception: (
    <>
      <path d="M3 7h11v9H3z" />
      <path d="M14 10h4l3 3v3h-7" />
      <circle cx="7" cy="18" r="1.8" />
      <circle cx="17" cy="18" r="1.8" />
    </>
  ),
  ventes: (
    <>
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  fournisseurs: (
    <>
      <path d="M12 3v18" />
      <path d="M5 7h14" />
      <path d="M5 7l-3 7h6z" />
      <path d="M19 7l-3 7h6z" />
    </>
  ),
  fournisseursConfig: (
    <>
      <path d="M4 7h16v12H4z" />
      <path d="M8 7V5h8v2" />
      <path d="M8 12h8M8 15h5" />
    </>
  ),
  inventaire: (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4h6v3H9z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  camera: (
    <>
      <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
      <circle cx="12" cy="13" r="3.5" />
    </>
  ),
  alert: (
    <>
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </>
  ),
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M20 20l-4-4" />
    </>
  ),
  chevron: <path d="M9 6l6 6-6 6" />,
  sync: (
    <>
      <path d="M21 12a9 9 0 0 1-15.5 6.2L3 16" />
      <path d="M3 12a9 9 0 0 1 15.5-6.2L21 8" />
      <path d="M21 3v5h-5M3 21v-5h5" />
    </>
  ),
  associations: (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </>
  ),
  fusions: (
    <>
      <path d="M8 7h8v4H8z" />
      <path d="M5 13h6v4H5z" />
      <path d="M13 13h6v4h-6z" />
      <path d="M12 11v2" />
    </>
  ),
};

export function Icon({ name }: { name: keyof typeof paths | string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}

export function Pill({ kind, children }: { kind: "ok" | "warn" | "bad" | "info"; children: ReactNode }) {
  return <span className={`pill ${kind}`}>{children}</span>;
}

export function Delta({ d }: { d: number }) {
  if (d > 0) return <span className="delta plus">+{d}</span>;
  if (d < 0) return <span className="delta minus">{d}</span>;
  return <span className="delta zero">0</span>;
}

export function PillStatut({ statut }: { statut: "ok" | "bas" | "rupture" }) {
  if (statut === "rupture") return <Pill kind="bad">Rupture</Pill>;
  if (statut === "bas") return <Pill kind="warn">Sous le seuil</Pill>;
  return <Pill kind="ok">OK</Pill>;
}
